export class DownTimeReasonRequest{
    downtimereasonId : number;
    
    constructor(downtimereasonId : number)
    {
        this.downtimereasonId = downtimereasonId;
        
    }
}
